import React from 'react';
import ChipComponent from './ChipComponent';
import { useEditorContext } from '../../logic/EditorContext';
import { objectTypeToIconName } from '../../../icon/utils';
var ChipDecorator = function (_a) {
    var contentState = _a.contentState, entityKey = _a.entityKey, blockKey = _a.blockKey, start = _a.start, end = _a.end, children = _a.children;
    var _b = useEditorContext(), componentHelper = _b[0], chipsHelper = _b[3];
    var chipData = contentState.getEntity(entityKey).getData();
    var chipReference = chipsHelper.getChipReference(chipData);
    var iconName = chipReference ? objectTypeToIconName(chipReference.objectType) : undefined;
    var handleClick = chipsHelper.onChipClick
        ?
            function () {
                var _a;
                (_a = chipsHelper.onChipClick) === null || _a === void 0 ? void 0 : _a.call(chipsHelper, chipReference);
            }
        : undefined;
    var handleDeleteClick = function () {
        chipsHelper.removeChip(blockKey, start, end);
    };
    return (React.createElement(ChipComponent, { label: chipReference === null || chipReference === void 0 ? void 0 : chipReference.name, fullName: chipReference === null || chipReference === void 0 ? void 0 : chipReference.name, iconName: iconName, active: !!chipReference, readOnly: !componentHelper.editModeActive, onClick: handleClick, onDelete: handleDeleteClick, children: children }));
};
export default ChipDecorator;
//# sourceMappingURL=ChipDecorator.js.map